"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const design_system_1 = require("@zapier/design-system");
const LogoImage_1 = __importDefault(require("../../LogoImage"));
const authBoxStyle = core_1.css `
  display: inline-block;
  padding: 4px 8px;
  border-radius: 5px;
  background-color: ${design_system_1.Colors.grey100};
`;
const AuthBox = ({ api, authTitle }) => (core_1.jsx("span", { css: authBoxStyle },
    core_1.jsx(LogoImage_1.default, { app: api, backgroundType: "clear", borderPadding: 0, size: 12 }),
    "\u00A0",
    authTitle));
exports.default = AuthBox;
